import React from 'react';
import PropTypes from 'prop-types';
import renderSvg from '@/utils/renderSvg';

import InspectionFinalized from '@/components/common/icons/activity-log/inspection-finalized.svg';
import InspectionScheduled from '@/components/common/icons/activity-log/inspection-scheduled.svg';
import OrderCreated from '@/components/common/icons/activity-log/order-created.svg';
import OrderSent from '@/components/common/icons/activity-log/order-sent.svg';
import PriceChanged from '@/components/common/icons/activity-log/price-changed.svg';
import ReportDownloaded from '@/components/common/icons/activity-log/report-downloaded.svg';

const iconMap = {
  INSPECTION_FINALIZED: InspectionFinalized,
  INSPECTION_SCHEDULED: InspectionScheduled,
  ORDER_CREATED: OrderCreated,
  ORDER_SENT: OrderSent,
  REPORT_DOWNLOADED: ReportDownloaded,
  ORDER_PRICE_CHANGED: PriceChanged,
};

const Icon = ({ action, className }) => {
  const src = iconMap[action] || InspectionFinalized;
  return renderSvg(src, { className, alt: action });
};

Icon.propTypes = {
  action: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
